import { render, staticRenderFns } from "./SwiperContentSliderPage.vue?vue&type=template&id=4d4d5a2a&"
import script from "./SwiperContentSliderPage.vue?vue&type=script&lang=ts&"
export * from "./SwiperContentSliderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports